import AccountListReport from './accountList';
import AccountSystemList from './accountSystemList/accountSystemList';
import BranchApi from 'api/branch';
import DealerApi from 'api/dealer';
import events from 'lib/events';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import MissingInformation from './missingInformation/missingInformation';
import NewAccountReport from './newAccounts';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import TruBlue from './truBlue/truBlue';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'helpers/performanceFile';
import {intlShape, injectIntl} from 'react-intl';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

//Register in router
const render = (container, params) => {
  console.info('[UI.page.reports.customer] rendering page');
  ReactDOM.render(<IntlWrapper><CustomerReport subPageName={params.subPage}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports.customer] register route');
router.rr.add([{path: 'reports/customer/:subPage', handler: routeUtils.requireAdmin(render)}]);

class _CustomerReport extends Component {
  static propTypes = {
    subPageName: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      user: session.getUser(),
      loaded: false,
    };
  }

  componentWillMount() {
    const apis = [];

    apis.push(BranchApi.getMyBranches());
    apis.push(DealerApi.getDealer(this.state.user.dealerId));
    Promise.all(apis)
      .then(([branches, dealer]) => {
        console.log('branches', branches);
        console.log('dealer', dealer);
        this.setState({
          loaded: true,
          dealer: dealer,
          branches: branches,
        });
      }).catch(err => {
        console.log('error', err);
      });
  }

  checkPOSPermission() {
    const {user, dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    } else if (user.isDealerAdmin) {
      return true;
    } else if (user.isAdmin && dealer.managerDetailedReporting) {
      return true;
    } else if (user.isTestStation && dealer.testerDetailedReporting) {
      return true;
    } else {
      return false;
    }
  }

  checkTruBlueDealerStatus = () => {
    const {dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    return dealer && dealer.isTruBlueEligible;
  };

  render() {
    const {subPageName} = this.props;
    const {branches} = this.state;
    let {formatMessage} = this.props.intl;

    const subPages = {
      'account-list': {
        name: formatMessage({id: 'reports.customer.all.accounts'}),
        element: <AccountListReport branches={this.state.branches}
                                    POSActive={this.checkPOSPermission()}
                                    TruBlueActive={this.checkTruBlueDealerStatus()}/>,
      },
      'system-list': {
        name: formatMessage({id: 'reports.customer.all.systems'}),
        element: <AccountSystemList branches={this.state.branches}
                                    dealer={this.state.dealer}
                                    TruBlueActive={this.checkTruBlueDealerStatus()}/>,
      },
      'new-accounts': {
        name: formatMessage({id: 'reports.customer.new.accounts'}),
        element: <NewAccountReport branches={this.state.branches}
                                   POSActive={this.checkPOSPermission()}
                                   TruBlueActive={this.checkTruBlueDealerStatus()}/>,
      },
      'trublue-accounts': {
        name: formatMessage({id: 'reports.customer.trublue.accounts'}),
        element: <TruBlue branches={this.state.branches}
                          POSActive={this.checkPOSPermission()}/>,
      },
      'missing-information': {
        name: formatMessage({id: 'reports.customer.missing.information'}),
        element: <MissingInformation branches={this.state.branches}/>,
      },
    };

    const subPagesTabs = Object.keys(subPages)
      .filter(sp => !subPages[sp].truBlueOnly || subPages[sp].truBlueOnly && this.checkTruBlueDealerStatus())
      .map(sp => <a key={sp}
                    className={subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
                    href={'#reports/customer/' + sp}>{subPages[sp].name}
      </a>);

    const subPage = subPages[subPageName].element;

    return (
      <div className='container'>
        <div id='page-reports'>
          <div className='nav-tabs'>
            <Header mainTitle={formatMessage({id: 'reports.title'})}
                    subTitle={formatMessage({id: 'reports.customer.accounts'})}
                    mainTitleReturn='reports'/>
          </div>
          <nav className='navigation-tabs'>
            {subPagesTabs}
          </nav>
          <Loader loaded={this.state.loaded}>
            <div className='report-details'>
              {subPage}
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

const CustomerReport = injectIntl(bindLocaleUpdate(connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_CustomerReport)));

export default CustomerReport;
